import { Injectable } from '@angular/core';
import { ServiceHandlerService } from '@shared/services/service-handler.service';
import { ValidateBankAccountResponse } from '@usf/payment-types';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface BankNameResponse {
  bankName: string;
}

@Injectable({
  providedIn: 'root',
})
export class BankService {
  constructor(private serviceHandler: ServiceHandlerService) {}

  getBankName(routingNumber: string): Observable<BankNameResponse> {
    return this.serviceHandler
      .get<BankNameResponse>(
        `${environment.paymentBankApiUrl}/bankName?routingNumber=${routingNumber}`,
      )
      .pipe(
        take(1),
        filter((res): res is BankNameResponse => !!res),
        catchError(error => throwError(() => error)),
      );
  }

  validateRoutingNumber(
    routingNumber: string,
    accountNumber: string,
  ): Observable<ValidateBankAccountResponse> {
    const body = {
      routingNumber: routingNumber,
      accountNumber: accountNumber,
    };
    return this.serviceHandler
      .post<ValidateBankAccountResponse>(
        `${environment.paymentBankApiUrl}/validateBankAccount`,
        body,
      )
      .pipe(
        take(1),
        filter(res => !!res),
        catchError(error => throwError(() => error)),
      );
  }
}
